module.exports = __webpack_public_path__ + "img/horizontal_3_5_pp3_8004.f0e3be06.png";